import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import Parse from 'parse'

import { useAccount } from '../contexts/authContext'
import { taskQueryKeys } from '../hooks/tasks/queries'
import { AlterationEvent, Account } from '../lib/parse'

function useAlterationSubscription() {
  const { account } = useAccount()
  const accountId = account.objectId
  const queryClient = useQueryClient()

  useEffect(() => {
    let subscription: Parse.LiveQuerySubscription | null = null

    const listener = () => {
      queryClient.invalidateQueries(taskQueryKeys.lists(), { exact: false })
    }

    async function initParse() {
      let query = new Parse.Query(AlterationEvent).equalTo(
        'account',
        new Account({ id: accountId })
      )

      subscription = await query.subscribe()
      subscription.on('create', listener)
    }

    if (!subscription && accountId) initParse()

    return () => {
      if (subscription) {
        subscription.unsubscribe()
      }
    }
  }, [accountId, queryClient])
}

export { useAlterationSubscription }
